console.log('✅ select-currency-top.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { appState, getArrowToggleDownIconSVG } from '../../js/state.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { convertStringToDecimal } from '../../js/utils-convert-numbers.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

const lang = appState.SiteLanguageCookie;

export async function buildComponentSelectCurrencyTop() {
  console.log(`🔄 Building Component: SelectCurrencyTop - lang: ${lang}`);

  try {
    await initTempTextTranslator(lang);
    await initTempLinksTranslator(lang);

    const {
      keyApplyEstimate: textkeyApplyEstimate,
      keyReset: textkeyReset,
        keyMsgTopExchangeRateDisclaimer: textkeyExchangeRateDisclaimer,
    } = _tempTextTranslator;

    //const {
    //    keySubcategories: linkSubcategories,

    //}
    //    = _tempLinksTranslator;

    // <img src="${dropdownIcon}" class="new-currency-dropdown-icon" width="20" height="20" />
    //  const downIconSVG = getArrowToggleDownIconSVG("new-currency-dropdown-icon", 20);

    //// ✅ Fetch all translations in parallel
    //const [
    //    textkeyApplyEstimate,
    //    textkeyReset,
    //    textkeyExchangeRateDisclaimer
    //] = await Promise.all([
    //    getTextTranslationByKey("keyApplyEstimate", lang),
    //    getTextTranslationByKey("keyReset", lang),
    //    getTextTranslationByKey("keyExchangeRateDisclaimer", lang),
    //]);

    // Get saved values from appState or default
    const selectedCurrencyCode = appState.SiteCurrencyCodeCookie || 'USD';
    const selectedCurrencyRate = appState.SiteCurrencyRateCookie || '1.00';
    const selectedCurrencySignSingle = appState.SiteCurrencySignSingleCookie || '$';

    const imgSrcForIcons = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/`;
    const dropdownIcon = `${imgSrcForIcons}arrow-toggle-down.svg`;

    const html = `
            <div class="divTopCurrencyWrapper" tabindex="0">
                <div id="dropbtnSelectSiteCurrency-Button">
                    <div class="new-currency-container">
                        <div class="new-currency-code">${selectedCurrencySignSingle} ${selectedCurrencyCode}</div>
                       
                       <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="new-currency-dropdown-icon">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    </svg>
                    </div>
                </div>

                <div id="dropDownSelectSiteCurrency" class="dropbtnSelectSiteCurrency-content" style="display: none;">
                    <div style="display:block;width:300px;">
                        <button class="divCurrencyClose">x</button><br/><br/>
                      
                        $1 USD = 
                        <select id="DropDownSiteCurrency" class="selectCurrencyDropDown">
                            <option value="${selectedCurrencyCode}">${selectedCurrencySignSingle} ${selectedCurrencyCode}</option>
                        </select>
                        at <input type="text" id="txtExchangeRate" class="textBoxCurrency" value="${selectedCurrencyRate}" />
                        <div class="divCurrencyDisclaimer">
                            * ${textkeyExchangeRateDisclaimer} 
                        </div>
                          <span class="loading-spinner currency-spinner" style="display: none;"></span> 
                        <button id="btnApplyCurrency" class="my-basic-btn my-basic-width-100 my-basic-padding-10">${textkeyApplyEstimate}</button>
                        <button id="btnResetCurrency" class="my-basic-btn my-basic-width-100 my-basic-padding-5">${textkeyReset}</button>
                    </div>
                </div>
            </div>`;

    console.log('✅ SelectCurrencyTop built successfully.');

    // Register event listeners
    registerEventListenerToAttach(initComponentSelectCurrencyTop);

    return html;
  } catch (err) {
    console.error('❌ Error building SelectCurrencyTop:', err);
    return '<div>Error loading currency selector</div>';
  }
}

export function initComponentSelectCurrencyTop() {
  try {
    const currencyButton = document.querySelector('#dropbtnSelectSiteCurrency-Button');
    const dropdown = document.querySelector('#dropDownSelectSiteCurrency');
    const closeBtn = document.querySelector('.divCurrencyClose');
    const btnApply = document.querySelector('#btnApplyCurrency');
    const btnReset = document.querySelector('#btnResetCurrency');
    const currencyDropdown = document.querySelector('#DropDownSiteCurrency');
    const txtExchangeRate = document.querySelector('#txtExchangeRate');
    const wrapperDiv = document.querySelector('.divTopCurrencyWrapper');

    if (
      !currencyButton ||
      !dropdown ||
      !btnApply ||
      !btnReset ||
      !currencyDropdown ||
      !txtExchangeRate
    ) {
      console.warn('⚠️ Some required elements not found, skipping SelectCurrencyTop setup.');
      return;
    }

    let isDropdownOpen = false;

    const toggleDropdownHandler = async () => {
      isDropdownOpen = !isDropdownOpen;
      dropdown.style.display = isDropdownOpen ? 'block' : 'none';

      if (isDropdownOpen) {
        console.log('🌐 Populating currencies on dropdown open');
        await populateCurrencyDropdown();
        currencyDropdown.value = appState.SiteCurrencyCodeCookie || 'USD';
        txtExchangeRate.value = appState.SiteCurrencyRateCookie || '1.00';
        setExchangeRate();
      }
    };

    const closeDropdownHandler = () => {
      isDropdownOpen = false;
      dropdown.style.display = 'none';
    };

    const currencyChangeHandler = () => {
      updateExchangeRate();
    };

    const applyCurrencyHandler = async () => {
      await applyCurrencyChange();
      isDropdownOpen = false;
    };

    const resetCurrencyHandler = async () => {
      await resetCurrency();
      isDropdownOpen = false;
    };

    // Safely remove existing listeners first
    currencyButton.removeEventListener('click', toggleDropdownHandler);
    currencyButton.addEventListener('click', toggleDropdownHandler);

    closeBtn?.removeEventListener('click', closeDropdownHandler);
    closeBtn?.addEventListener('click', closeDropdownHandler);

    currencyDropdown.removeEventListener('change', currencyChangeHandler);
    currencyDropdown.addEventListener('change', currencyChangeHandler);

    btnApply.removeEventListener('click', applyCurrencyHandler);
    btnApply.addEventListener('click', applyCurrencyHandler);

    btnReset.removeEventListener('click', resetCurrencyHandler);
    btnReset.addEventListener('click', resetCurrencyHandler);

    document.removeEventListener('click', closeDropdownHandler);
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target) && !currencyButton.contains(event.target)) {
        closeDropdownHandler();
      }
    });

    console.log('✅ SelectCurrencyTop event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to SelectCurrencyTop:', error);
  }
}

//export function initComponentSelectCurrencyTop() {
//    try {
//        const currencyButton = document.querySelector("#dropbtnSelectSiteCurrency-Button");
//        const dropdown = document.querySelector("#dropDownSelectSiteCurrency");
//        const closeBtn = document.querySelector(".divCurrencyClose");
//        const btnApply = document.querySelector("#btnApplyCurrency");
//        const btnReset = document.querySelector("#btnResetCurrency");
//        const currencyDropdown = document.querySelector("#DropDownSiteCurrency");
//        const txtExchangeRate = document.querySelector("#txtExchangeRate");
//        const wrapperDiv = document.querySelector(".divTopCurrencyWrapper");

//        let isDropdownOpen = false;

//        const toggleDropdown = async () => {
//            isDropdownOpen = !isDropdownOpen;
//            dropdown.style.display = isDropdownOpen ? "block" : "none";

//            // Populate the dropdown every time it's shown
//            if (isDropdownOpen) {
//                console.log("🌐 Populating currencies on dropdown open");
//                await populateCurrencyDropdown();

//                // Update the exchange rate after populating
//                currencyDropdown.value = appState.SiteCurrencyCodeCookie || "USD";
//                txtExchangeRate.value = appState.SiteCurrencyRateCookie || "1.00";

//                setExchangeRate();
//            }
//        };

//        const closeDropdown = () => {
//            isDropdownOpen = false;
//            dropdown.style.display = "none";
//        };

//        // Toggle dropdown on button click
//        currencyButton?.addEventListener("click", () => toggleDropdown());

//        // Listen for currency selection change
//        currencyDropdown?.addEventListener("change", () => updateExchangeRate());

//        document.addEventListener("click", (event) => {
//            if (!dropdown.contains(event.target) && !currencyButton.contains(event.target)) {
//                closeDropdown();
//            }
//        });

//        //// One-time click listener to load currencies and set the initial exchange rate
//        //const onFirstClick = async () => {

//        //    console.log("✅ Currencies loaded on first wrapper click");

//        //    await populateCurrencyDropdown();

//        //    // Update the exchange rate after the dropdown is populated
//        //    updateExchangeRate();

//        //    // Remove this event listener after the first successful load
//        //    wrapperDiv.removeEventListener("click", onFirstClick);
//        //};

//        //// Attach the one-time click listener to the wrapper div
//        //wrapperDiv?.addEventListener("click", onFirstClick);

//        closeBtn?.addEventListener("click", closeDropdown);

//        btnReset?.addEventListener("click", async () => {

//            await resetCurrency();

//            // putting this here due to issue when display none is applied outside

//            isDropdownOpen = false;
//        });

//        btnApply?.addEventListener("click", async () => {

//            await applyCurrencyChange();

//            // putting this here due to issue when display none is applied outside
//            isDropdownOpen = false;
//        });

//        console.log("✅ SelectCurrencyTop event listeners attached.");
//    } catch (error) {
//        console.error("❌ Error attaching event listeners to SelectCurrencyTop:", error);
//    }
//}

async function populateCurrencyDropdown() {
  console.log('✅ Populating currencies dropdown...');

  const dropdown = document.querySelector('#DropDownSiteCurrency');
  const storageKey = `currencies_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedCurrencies = loadFromLocalStorage(storageKey);

  // Check if we have valid cached data
  if (cachedCurrencies && Array.isArray(cachedCurrencies) && cachedCurrencies.length > 0) {
    console.log('✅ Loaded currencies from cache');
    await renderCurrencyOptions(dropdown, cachedCurrencies);
    return;
  }

  // Start the fetch promise immediately
  const fetchPromise = fetchCurrencies();

  // Show spinner if loading takes more than 1 second
  let spinnerIsVisible = false;
  const delayPromise = new Promise(resolve => {
    setTimeout(() => {
      spinnerIsVisible = true;
      showSpinner('.currency-spinner');
      resolve();
    }, 1000);
  });

  try {
    // Wait for both fetch and spinner delay
    await Promise.all([fetchPromise, delayPromise]);

    // Get the fetched currencies
    const currencies = await fetchPromise;
    if (currencies.length === 0) return;

    await renderCurrencyOptions(dropdown, currencies);
    console.log('🌐 Fetched currencies from server');
  } catch (error) {
    console.error('❌ Error loading currencies:', error);
  } finally {
    // Hide the spinner if it was shown
    if (spinnerIsVisible) {
      hideSpinner('.currency-spinner');
    }
  }
}

async function renderCurrencyOptions(dropdown, currencies) {
  dropdown.innerHTML = ''; // Clear existing options

  currencies.forEach(currency => {
    const option = document.createElement('option');
    option.value = currency.currencyCode;
    option.textContent = `${currency.currencySign} ${currency.currencyCode}`;

    // Attach additional currency data to the option element
    option.dataset.exchangeRate = currency.exchangeRate;
    option.dataset.currencySignSingle = currency.currencySign;
    option.dataset.currencySignMultiple = currency.currencySignMultiple;

    dropdown.appendChild(option);
  });
}

//async function populateCurrencyDropdown() {

//    console.log("✅ Pupulating currencies dropdown...");

//    const dropdown = document.querySelector("#DropDownSiteCurrency");

//    // Apply the delay specifically in this method
//  //  const delayPromise = new Promise((resolve) => setTimeout(resolve, 1000));
//   // const showSpinnerPromise = delayPromise.then(() => showSpinner(".currency-spinner"));

//    // Start the fetch promise immediately
//    const fetchPromise = fetchCurrencies();

//    // Start the delay timer (1 second)
//    let spinnerIsVisible = false;
//    const delayPromise = new Promise((resolve) => {
//        setTimeout(() => {
//            spinnerIsVisible = true;
//            showSpinner(".currency-spinner");
//            resolve();
//        }, 1000); // Show spinner after 1 second
//    });

//    try {
//       // // Start both the spinner delay and the API call simultaneously
//      //  const currencies = await Promise.race([fetchCurrencies(), showSpinnerPromise]);

//        // Wait for either the fetch to complete or the delay to finish
//        await Promise.all([fetchPromise, delayPromise]);

//        // Get the fetched currencies
//        const currencies = await fetchPromise;

//        currencies.forEach(currency => {
//            const option = document.createElement("option");
//            option.value = currency.currencyCode;
//            option.textContent = `${currency.currencySign} ${currency.currencyCode}`;

//            option.dataset.exchangeRate = currency.exchangeRate;
//            option.dataset.currencySignSingle = currency.currencySign;
//            option.dataset.currencySignMultiple = currency.currencySignMultiple;

//            dropdown.appendChild(option);
//        });

//        console.log("🌐 Fetched currency from server");
//    } catch (error) {
//        console.error("❌ Error loading currencies:", error);
//    } finally {
//        // Hide the spinner after loading is complete

//        if (spinnerIsVisible) {
//            hideSpinner(".currency-spinner");
//        }

//    }

//}

async function fetchCurrencies(forceRefresh = false) {
  const storageKey = `currencies_${appState.SiteLanguageCookie}`;
  const expiryKey = `${storageKey}_expiry`;
  const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

  if (!forceRefresh) {
    const cached = loadFromLocalStorage(storageKey);
    const expiryTime = loadFromLocalStorage(expiryKey);

    if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
      console.log('✅ Loaded currencies from cache');
      return cached;
    }
  }

  try {
    const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CurrencyDataService/GetListOfAllCurrencies`;
    const response = await fetch(apiEndPoint);

    if (!response.ok) throw new Error('Failed to fetch currencies from the server');

    const currencies = await response.json();
    saveToLocalStorage(storageKey, currencies);
    saveToLocalStorage(expiryKey, Date.now() + expiryDuration);

    console.log('🌐 Fetched currencies from the server');
    return currencies;
  } catch (error) {
    console.error('❌ Error fetching currencies:', error);
    return [];
  }
}

//async function fetchCurrencies() {
//    try {
//        const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CurrencyDataService/GetListOfAllCurrencies`;
//        const response = await fetch(apiEndPoint);

//        if (!response.ok) throw new Error("Failed to fetch currencies");

//        const currencies = await response.json();
//        return currencies;
//    } catch (error) {
//        console.error("❌ Error fetching currencies:", error);
//        return [];
//    }
//}

function updateExchangeRate() {
  // from the dropdown
  const dropdown = document.querySelector('#DropDownSiteCurrency');
  const txtExchangeRate = document.querySelector('#txtExchangeRate');

  const selectedOption = dropdown?.selectedOptions[0];
  if (!selectedOption) return;

  const selectedValue = selectedOption.value;
  const exchangeRate = selectedOption.dataset.exchangeRate || '1.00'; // Fallback to 1.00 if not found

  if (selectedValue === 'USD') {
    txtExchangeRate.value = '1.00';
    txtExchangeRate.disabled = true;
  } else {
    txtExchangeRate.value = exchangeRate;
    txtExchangeRate.disabled = false;
  }

  console.log(`✅ Currency changed: ${selectedValue}, Exchange Rate: ${txtExchangeRate.value}`);
}

function setExchangeRate() {
  // from values

  const dropdown = document.querySelector('#DropDownSiteCurrency');
  const txtExchangeRate = document.querySelector('#txtExchangeRate');

  const selectedOption = dropdown?.selectedOptions[0];
  if (!selectedOption) return;

  const selectedValue = selectedOption.value;
  const exchangeRate = txtExchangeRate.value || '1.00'; // Fallback to 1.00 if not found

  if (selectedValue === 'USD') {
    txtExchangeRate.value = '1.00';
    txtExchangeRate.disabled = true;
  } else {
    txtExchangeRate.value = exchangeRate;
    txtExchangeRate.disabled = false;
  }

  console.log(`✅ Currency changed: ${selectedValue}, Exchange Rate: ${txtExchangeRate.value}`);
}

async function applyCurrencyChange() {
  const btnApply = document.querySelector('#btnApplyCurrency');

  // Add the loading class
  btnApply.classList.add('myloading');

  const dropdown = document.querySelector('#DropDownSiteCurrency');
  const selectedOption = dropdown?.selectedOptions[0];

  const txtExchangeRate = document.querySelector('#txtExchangeRate');

  if (selectedOption) {
    const selectedCurrencyCode = selectedOption?.value;

    const selectedCurrencyRate = txtExchangeRate.value || '1.00';

    const selectedCurrencySignSingle = selectedOption?.dataset.currencySignSingle || '$';
    const selectedCurrencySignMultiple = selectedOption?.dataset.currencySignMultiple || '$';

    if (
      convertStringToDecimal(selectedCurrencyRate) === 0 ||
      convertStringToDecimal(selectedCurrencyRate) < 0
    ) {
      console.error('❌ Invalid exchange rate entered');

      btnApply.classList.remove('myloading');

      resetCurrency();
    } else {
      // save to appState
      appState.SiteCurrencyCodeCookie = selectedCurrencyCode;
      appState.SiteCurrencyRateCookie = selectedCurrencyRate;
      appState.SiteCurrencySignSingleCookie = selectedCurrencySignSingle;
      appState.SiteCurrencySignMultipleCookie = selectedCurrencySignMultiple;

      // Save the selected values to localStorage
      saveToLocalStorage('SiteCurrencyCodeCookie', selectedCurrencyCode);
      saveToLocalStorage('SiteCurrencyRateCookie', selectedCurrencyRate);
      saveToLocalStorage('SiteCurrencySignSingleCookie', selectedCurrencySignSingle);
      saveToLocalStorage('SiteCurrencySignMultipleCookie', selectedCurrencySignMultiple);

      // Update UI
      const currencyCodeDiv = document.querySelector('.new-currency-code');
      currencyCodeDiv.textContent = `${selectedCurrencySignSingle} ${selectedCurrencyCode}`;

      console.log(
        `✅ Currency changed to: ${selectedCurrencyCode} at rate: ${selectedCurrencyRate}`
      );
    }
  }

  setTimeout(() => {
    closeDropdown();

    btnApply.classList.remove('myloading');
  }, 1500);
}

function resetCurrency() {
  const btnResetCurrency = document.querySelector('#btnResetCurrency');

  // Add the loading class
  btnResetCurrency.classList.add('myloading');

  const dropdown = document.querySelector('#DropDownSiteCurrency');
  const txtExchangeRate = document.querySelector('#txtExchangeRate');
  const currencyCodeDiv = document.querySelector('.new-currency-code');

  dropdown.value = 'USD';
  txtExchangeRate.value = '1.00';
  txtExchangeRate.disabled = true;

  // Update UI
  currencyCodeDiv.textContent = '$ USD';

  // Reset appState values
  appState.SiteCurrencyCodeCookie = 'USD';
  appState.SiteCurrencyRateCookie = '1.00';
  appState.SiteCurrencySignSingleCookie = '$';
  appState.SiteCurrencySignMultipleCookie = '$';

  // Save the default values to localStorage
  saveToLocalStorage('SiteCurrencyCodeCookie', 'USD');
  saveToLocalStorage('SiteCurrencyRateCookie', '1.00');
  saveToLocalStorage('SiteCurrencySignSingleCookie', '$');
  saveToLocalStorage('SiteCurrencySignMultipleCookie', '$');

  console.log('✅ Currency reset to USD with rate 1.00');

  setTimeout(() => {
    closeDropdown();

    btnResetCurrency.classList.remove('myloading');
  }, 1500);
}

function closeDropdown() {
  const dropdown = document.querySelector('#dropDownSelectSiteCurrency');

  if (dropdown) {
    dropdown.style.display = 'none';
  }
}

function showSpinner(spinnerClass) {
  const spinner = document.querySelector(spinnerClass);
  if (spinner) spinner.style.display = 'inline-block';
}

function hideSpinner(spinnerClass) {
  const spinner = document.querySelector(spinnerClass);
  if (spinner) spinner.style.display = 'none';
}
